import { Tooltip, Typography } from '@mui/material';
import React from 'react';
import { truncateString } from "../../commonFunctions/CommonFunctions";

// Define an interface for your component props
interface StatusProps {
    value: string;
    toolTip?: boolean
}

// Function to determine the color based on the status value
const getStatusColor = (value: string): string => {
    switch (value.toLowerCase()) {
        case 'active':
            return 'green';
        case 'in active':
            return 'red';
        case 'pending':
            return 'orange';
        default:
            return 'black'; // Default color if the status doesn't match any case
    }
};

// Define and export the memoized component in one line
export const WSStatus: React.FC<StatusProps> = React.memo(({ value, toolTip = false }) => {
    const statusColor = getStatusColor(value);
    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            {toolTip ? (
                <Tooltip title={value} placement="top">
                    <Typography style={{ color: statusColor }}>{truncateString(value, 20)}</Typography>
                </Tooltip>
            ) : (
                <Typography style={{ color: statusColor }}>{value}</Typography>
            )}
        </div>
    );
});
